import { object, string } from 'yup';
export const metaConfigurationStatusTagMap = {
    NOT_CONNECTED: {
        label: 'Not connected',
        appearance: 'alert',
    },
    CONFIGURED: {
        label: 'Configured',
        appearance: 'success',
    },
    NOT_CONFIGURED: {
        label: 'Requires setup',
        appearance: 'alert',
    },
};
export const ConfigureSchema = object({
    metaCatalogId: string().required(),
});
